import classNames from 'classnames';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { getImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { Image } from 'wix-rich-content-ui-components';
import { s as styles } from '../audio.rtlignore-ba5af086.js';
import '../style-inject.es-e7b07dd7.js';

const AudioImage = ({ getImageUrl, coverImage, isSmallImage }) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    Image,
    {
      uri: getImageSrc({ file_name: coverImage.src }, getImageUrl, {
        requiredWidth: 84,
        requiredHeight: 84,
        requiredQuality: 70
      }),
      width: 84,
      height: 84,
      className: classNames(styles.audio_coverImg, {
        [styles.audio_small_cover_image]: isSmallImage
      }),
      displayMode: "fill",
      alt: t("Audio_Plugin_Cover_Alt")
    }
  );
};

export { AudioImage as default };
//# sourceMappingURL=AudioImage.js.map
